// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__rOZyY","icon":"styles_icon__0fCQC","prev":"styles_prev__4JYVG","next":"styles_next__tN93l","prevIcon":"styles_prevIcon__a0s-E"};